// src/translationService.js
import axios from 'axios';

const API_KEY = 'AIzaSyB6yFsjLrTu7gUDIMCOdBfacsSh3J_rXIE'; //TODO

const translateText = async (text, targetLanguage) => {
  try {
    const response = await axios.post(
      `https://translation.googleapis.com/language/translate/v2`,
      {},
      {
        params: {
          q: text,
          target: targetLanguage,
          key: API_KEY,
          format: 'text',
        },
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data.data.translations[0].translatedText;
  } catch (error) {
    console.error('Error translating text:', error.response ? error.response.data : error.message);
    throw error;
  }
};

export default translateText;